<!-- This example requires Tailwind CSS v2.0+ -->
<template>
    <div class="px-4">
        <div class="font-semibold text-gray-600 p-4 flex justify-between">
            <div>
                <span class="text-xs uppercase text-indigo-500">Kursy walut</span>
               <p class="py-0 my-0">Kantor "u Chowańca"</p>
                <span class="text-gray-500 text-xs">{{ date }}</span>
            </div>
            <a href="/app/shops/6" class="text-indigo-500 px-4 uppercase text-sm text-right">Więcej informacji</a>
        </div>
        <dl class="grid grid-cols-1 rounded-lg bg-white overflow-hidden shadow divide-y divide-gray-200 md:grid-cols-3 md:divide-y-0 md:divide-x">

            <div v-for="item in currencies" :key="item.name" class="px-4 py-5 sm:p-6">

                <dt class="pb-4 text-base text-lg font-normal text-gray-900 flex justify-between fa-align-center">
                    <div>
                        {{ item.name }}
                        <b>{{ item.symbol }}</b>
                    </div>

                    <img class="h-10" :src="item.src"/>
                </dt>


                <dd class="mt-1 flex justify-between items-baseline md:block lg:flex">
                    <div class="flex items-baseline text-2xl font-semibold text-indigo-600">
                        {{ item.sale }}
                    </div>
                    <div
                        class="'bg-green-100 text-green-800 inline-flex items-baseline px-2.5 py-0.5 rounded-full text-sm font-medium md:mt-2 lg:mt-0'">
                        SPRZEDAŻ
                    </div>
                </dd>
                <dd class="mt-1 flex justify-between items-baseline md:block lg:flex">
                    <div class="flex items-baseline text-2xl font-semibold text-indigo-600">
                        {{ item.purchase }}
                    </div>
                    <div
                        class="'bg-green-100 text-green-800 inline-flex items-baseline px-2.5 py-0.5 rounded-full text-sm font-medium md:mt-2 lg:mt-0'">
                        ZAKUP
                    </div>
                </dd>

            </div>
        </dl>
    </div>
</template>

<script>
import {ArrowSmDownIcon, ArrowSmUpIcon} from '@heroicons/vue/solid'
import {CursorClickIcon, MailOpenIcon, UsersIcon} from '@heroicons/vue/outline'

const stats = [
    {name: 'Total Subscribers', stat: '71,897', previousStat: '70,946', change: '12%', changeType: 'increase'},
    {name: 'Avg. Open Rate', stat: '58.16%', previousStat: '56.14%', change: '2.02%', changeType: 'increase'},
    {name: 'Avg. Click Rate', stat: '24.57%', previousStat: '28.62%', change: '4.05%', changeType: 'decrease'},
]

let currencies
let date
export default {
    name: "Currency",
    components: {ArrowSmDownIcon, ArrowSmUpIcon, CursorClickIcon, MailOpenIcon, UsersIcon},
    data: () => ({
        stats,
        date,
        currencies: []

    }),
    created: function () {
        this.getCurrencies();
    },
    methods: {
        async getCurrencies() {
            await fetch(`https://cloudpanel.pl/api/uchowanca/currency`)
                .then(response => response.json())
                .then(result => {
                    this.currencies = result.currencies;
                    this.date = result.date;
                    console.log(result.currencies)
                });
        }
    }
}

</script>

<style scoped>

</style>
